// @flow

import { getActiveClaimFreeId } from './claimFree';

const choiceGroupsValidationMapping = {
  packages: false,
  colors: false,
  durations: false,
  mileages: false,
  claim_free: state => !getActiveClaimFreeId(state),
  bundles: false,
  extras: false,
  insurances: false,
};

export const choiceGroupHasError = (state: any, type: string) => {
  const validate = choiceGroupsValidationMapping[type];
  if (!validate || typeof validate !== 'function') return false;
  return validate(state);
};

export const anyChoiceGroupHasError = (state: any) => Object
  .keys(choiceGroupsValidationMapping)
  .some(type => choiceGroupHasError(state, type) || false);

export default null;
